import * as actions from "actions/accessLevel";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case actions.CREATE_ONE_SUCCESS:
      return payload.data;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/accessLevel/item.js